import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
}) {
  const styles = {
    background: { bgcolor: "background.dialog", color: "background.text" },
    title: { fontWeight: 700, color: "background.text", overflowWrap: "anywhere" },
    message: { color: "background.textMuted", overflowWrap: "anywhere" },
    actions: { px: 3, py: 2 },
    button: { textTransform: "none" },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{ paper: { sx: styles.background } }}
    >
      <DialogTitle sx={styles.title}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={styles.message}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button onClick={onClose} sx={styles.button}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            onConfirm();
            onClose();
          }}
          sx={styles.button}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
